import { CloseOutlined, LinkOutlined } from '@ant-design/icons';
import { useLocation, useParams } from 'react-router-dom';

import { Divider, Flex } from '@/components/base';
import IconButton from '@/components/Button/IconButton';
import Tooltip from '@/components/Tooltip/TooltipV2';
import { usePublic } from '@/contexts/PublicContext';
import useKeymap from '@/hooks/pure/useKeymap';
import { useToast } from '@/stores/pure/ToastStore';
import { clipboardCopy } from '@/utils/util';

type HeaderProps = {
  closeModal: () => void;
  feedbackAlias: string;
};

const Header = (props: HeaderProps) => {
  const isPublic = usePublic();
  const addToast = useToast();
  const location = useLocation();
  const params = useParams();

  useKeymap('Escape', props.closeModal);

  return (
    <>
      <Flex a="center" j="flex-end" style={{ padding: '16px 32px' }}>
        <Flex g="8px" a="center">
          <Tooltip tooltipNode="Copy feedback link">
            <IconButton
              icon={<LinkOutlined />}
              outlined={true}
              onClick={() => {
                const link = isPublic
                  ? `${window.location.origin}${location.pathname}`
                  : params.workspace_id
                    ? `${window.location.origin}/workspace/${params.workspace_id}/feedbacks/${props.feedbackAlias}`
                    : `${window.location.origin}${location.pathname}`;
                clipboardCopy(link);
                addToast('Feedback link Copied', 'success');
              }}
            />
          </Tooltip>
          <IconButton
            onClick={props.closeModal}
            icon={<CloseOutlined />}
            tooltip="Close"
            shortcut="ESC"
          />
        </Flex>
      </Flex>
      <Divider />
    </>
  );
};

export default Header;
